import jsPDF from 'jspdf';
import logo from './driverQRCodeLogo';

// The driver's printable QR card. Reading order is the scanning order: the code
// first and large, the driver's name under it so a dispatcher can tell two cards
// apart, and the logo small at the foot where it brands without competing.
// Sized as a CR80 card held upright — the standard vertical ID badge, 2.125" x
// 3.375" (54 x 85.6 mm) — in points (72 per inch); jsPDF's "px" unit would be
// scaled by 96/72 and miss the size.
const CARD = { width: 153, height: 243 };

// Vertical badges are slot-punched at the top centre; the code starts below
// that strip so a punch never takes a bite out of it.
const QR = { size: 118, top: 34 };
// Baseline of the first name line, not its top.
const NAME = { top: 170, fontSize: 11, lineHeight: 13, maxLines: 3, maxWidth: CARD.width - 30 };
const LOGO = { width: 76, height: 76 / 5.26, bottom: 16 };

const generateQRCode = (driverName, id, fileName, qrCode) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'pt',
    format: [CARD.width, CARD.height],
  });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.addImage(qrCode, 'PNG', (pageWidth - QR.size) / 2, QR.top, QR.size, QR.size);

  // Wrapped, because a long full name would otherwise run off both edges; past
  // the last line it is cut rather than running into the logo.
  doc.setFont(undefined, 'bold');
  doc.setFontSize(NAME.fontSize);
  doc.setTextColor('#000000');
  doc
    .splitTextToSize(driverName || '', NAME.maxWidth)
    .slice(0, NAME.maxLines)
    .forEach((line, index) => {
      doc.text(line, pageWidth / 2, NAME.top + index * NAME.lineHeight, { align: 'center' });
    });

  // Pinned to the foot of the card so a long name can't shove it down.
  doc.addImage(
    logo,
    'PNG',
    (pageWidth - LOGO.width) / 2,
    pageHeight - LOGO.bottom - LOGO.height,
    LOGO.width,
    LOGO.height
  );

  doc.save(`${fileName}.pdf`);
};

export default generateQRCode;
